import AuthMenu from "@/components/auth-menu";
import MobileBackButton from "@/components/buttons/mobile-back-button";
import DesktopHeader, { HeaderStrategyEnum } from "@/components/header-v2";
import { ShareIcon } from "@/components/icons/share";
import { Button } from "@/components/ui/button";

interface HeaderProps {
  onShare(): void;
}

export default function Header({ onShare }: HeaderProps) {
  return (
    <>
      <DesktopHeader
        mobileClassName="hidden"
        strategy={HeaderStrategyEnum.fixed}
      />
      <header className="absolute inset-x-0 z-2 flex items-center px-6 pt-6 md:hidden">
        <MobileBackButton />
        <div className="ml-auto flex items-center gap-2.5">
          <Button
            aria-label="Share"
            className="ml-auto flex size-7.5"
            onClick={onShare}
          >
            <ShareIcon />
          </Button>
          <AuthMenu />
        </div>
      </header>
    </>
  );
}
